import { render, staticRenderFns } from "./ProductQuickview.vue?vue&type=template&id=0ca29818&scoped=true&lang=html"
import script from "./ProductQuickview.vue?vue&type=script&lang=js"
export * from "./ProductQuickview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca29818",
  null
  
)

export default component.exports